import React from 'react';
import { ResolveTimezoneInput, useApplyResolvedTimezone } from './useResolveTimezone';

interface TimezoneAutoResolveProps extends ResolveTimezoneInput {
  onResolved: (timezoneId: string) => void;
}

export const TimezoneAutoResolve: React.FC<TimezoneAutoResolveProps> = ({ countryCode3, city, postalCode, onResolved }) => {
  useApplyResolvedTimezone({ countryCode3, city, postalCode }, onResolved);
  return null;
};